export default __webpack_public_path__ + "static/media/Wheeltek Logo.0107ea93.png";